import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDGHLkmPv81dKGPE4u3EskXxT6SDfUuNqY",
  authDomain: "chat-with-me-cf6ac.firebaseapp.com",
  projectId: "chat-with-me-cf6ac",
  storageBucket: "chat-with-me-cf6ac.appspot.com",
  messagingSenderId: "921800049667",
  appId: "1:921800049667:web:ca1d897a677f2596933a36",
  measurementId: "G-9V1F9NEL5G"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore();
export const auth = getAuth(app);